webpackJsonp([1],{

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REGISTER_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REMINDER_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RESET_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RESET_CHECK_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LOGIN_URL; });
/* unused harmony export USER_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REPORT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INPUT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PROFILE_URL; });
function defineEnvironment() {
	var currentUrl = window.location.host;
	var apiUrl = void 0;
	switch (currentUrl) {
		case "tmf.staging.pdc.is":
			apiUrl = "https://api.tmf.staging.pdc.is/api";
			break;
		case "trackmyfcev.com":
			apiUrl = "https://api.trackmyfcev.com/api";
			break;
		default:
			apiUrl = "http://api.tmf.dev/api";
			break;
	}
	return apiUrl;
}

var API_URL = defineEnvironment();

// Auth group
var REGISTER_URL = "/auth/register";
var REMINDER_URL = "/auth/password/email";
var RESET_URL = "/auth/password/reset";
var RESET_CHECK_URL = "/auth/password/reset-check";
var LOGIN_URL = "/auth/login";

// Request
var USER_URL = "/user";
var REPORT_URL = "/reporting";
var INPUT_URL = "/refuel";
var PROFILE_URL = "/profile";

/***/ }),

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = decimal;
/* harmony export (immutable) */ __webpack_exports__["b"] = numeric;
function decimal(value) {
	return (/^[0-9.-]*$/.test(value)
	);
}

function numeric(value) {
	return (/^[0-9]*$/.test(value)
	);
}

/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_auth__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_auth_Login__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_auth_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_auth_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_auth_Register__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_auth_Register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_auth_Register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_auth_Reminder__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_auth_Reminder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_auth_Reminder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_auth_Reset__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_auth_Reset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_auth_Reset__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Dashboard__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Analysis__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Analysis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Analysis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Profile__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_History__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_History___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_History__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Edit__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Terms__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Terms___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_Terms__);



// Auth group





// App components







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	mode: "history",
	routes: [{
		path: "/",
		name: "Login",
		beforeEnter: __WEBPACK_IMPORTED_MODULE_2__utils_auth__["d" /* isAuthed */],
		component: __WEBPACK_IMPORTED_MODULE_3__components_auth_Login___default.a
	}, {
		path: "/register",
		name: "Register",
		beforeEnter: __WEBPACK_IMPORTED_MODULE_2__utils_auth__["d" /* isAuthed */],
		component: __WEBPACK_IMPORTED_MODULE_4__components_auth_Register___default.a
	}, {
		path: "/reminder",
		name: "Reminder",
		beforeEnter: __WEBPACK_IMPORTED_MODULE_2__utils_auth__["d" /* isAuthed */],
		component: __WEBPACK_IMPORTED_MODULE_5__components_auth_Reminder___default.a
	}, {
		path: "/reset",
		name: "Reset",
		beforeEnter: __WEBPACK_IMPORTED_MODULE_2__utils_auth__["d" /* isAuthed */],
		component: __WEBPACK_IMPORTED_MODULE_6__components_auth_Reset___default.a
	}, {
		path: "/profile",
		name: "Profile",
		beforeEnter: __WEBPACK_IMPORTED_MODULE_2__utils_auth__["e" /* requireAuth */],
		component: __WEBPACK_IMPORTED_MODULE_9__components_Profile___default.a
	}, {
		path: "/dashboard",
		name: "Dashboard",
		beforeEnter: __WEBPACK_IMPORTED_MODULE_2__utils_auth__["e" /* requireAuth */],
		component: __WEBPACK_IMPORTED_MODULE_7__components_Dashboard___default.a
	}, {
		path: "/analysis",
		name: "Analysis",
		beforeEnter: __WEBPACK_IMPORTED_MODULE_2__utils_auth__["e" /* requireAuth */],
		component: __WEBPACK_IMPORTED_MODULE_8__components_Analysis___default.a
	}, {
		path: "/history",
		name: "History",
		beforeEnter: __WEBPACK_IMPORTED_MODULE_2__utils_auth__["e" /* requireAuth */],
		component: __WEBPACK_IMPORTED_MODULE_10__components_History___default.a
	}, {
		path: "/history/:id",
		name: "edit-entry",
		beforeEnter: __WEBPACK_IMPORTED_MODULE_2__utils_auth__["e" /* requireAuth */],
		component: __WEBPACK_IMPORTED_MODULE_11__components_Edit___default.a
	}, {
		path: "/terms-conditions",
		name: "Terms",
		component: __WEBPACK_IMPORTED_MODULE_12__components_Terms___default.a
	}, {
		path: "*",
		name: "404",
		component: {
			template: "<div><h1>404</h1><hr><p>Sorry, this page does not exist.</p></div>"
		}
	}]
}));

/***/ }),

/***/ 297:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 298:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(469)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(632),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);

var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Bar"].extend({
	mixins: [reactiveProp],
	props: ["chartData", "options"],
	mounted: function mounted() {
		this.renderChart(this.chartData, this.options);
	}
}));

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);

var reactiveProp = __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp;


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Line"].extend({
	mixins: [reactiveProp],
	props: ["chartData", "options"],
	mounted: function mounted() {
		this.renderChart(this.chartData, this.options);
	}
}));

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_theme_index_css__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_theme_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_theme_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_en__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_store__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_auth__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__App__);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale_lang_en___default.a });

__WEBPACK_IMPORTED_MODULE_6_axios___default.a.defaults.baseURL = __WEBPACK_IMPORTED_MODULE_8__config__["a" /* API_URL */];
__WEBPACK_IMPORTED_MODULE_6_axios___default.a.defaults.withCredentials = true;
__WEBPACK_IMPORTED_MODULE_6_axios___default.a.defaults.headers = {
	"Access-Control-Allow-Origin": "*"
};

__WEBPACK_IMPORTED_MODULE_6_axios___default.a.interceptors.request.use(function (request) {
	__WEBPACK_IMPORTED_MODULE_9__utils_store__["a" /* default */].isLoading = true;
	return request;
});

__WEBPACK_IMPORTED_MODULE_6_axios___default.a.interceptors.response.use(function (response) {
	__WEBPACK_IMPORTED_MODULE_9__utils_store__["a" /* default */].isLoading = false;
	return response;
}, function (error) {
	__WEBPACK_IMPORTED_MODULE_9__utils_store__["a" /* default */].isLoading = false;
	if (error.request.status === 401 || error.request.status === 400) {
		__WEBPACK_IMPORTED_MODULE_10__utils_auth__["a" /* endSession */]();
	}
	return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuelidate___default.a);

/* eslint-disable no-new */
var app = new __WEBPACK_IMPORTED_MODULE_4_vue__["default"]({
	el: "#app",
	data: {
		app: __WEBPACK_IMPORTED_MODULE_9__utils_store__["a" /* default */]
	},
	router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
	template: "<App/>",
	components: { App: __WEBPACK_IMPORTED_MODULE_11__App___default.a },
	methods: {
		updateStatus: function updateStatus() {
			if (typeof window.navigator.onLine === "undefined") {
				this.app.isOnline = true;
			} else {
				this.app.isOnline = window.navigator.onLine;
			}
		}
	}
});

window.addEventListener("online", app.updateStatus);
window.addEventListener("offline", app.updateStatus);

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_auth__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_store__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
	name: "app",
	data: function data() {
		return {
			app: __WEBPACK_IMPORTED_MODULE_2__utils_store__["a" /* default */]
		};
	},
	methods: {
		getToken: __WEBPACK_IMPORTED_MODULE_1__utils_auth__["b" /* getToken */],
		getUser: __WEBPACK_IMPORTED_MODULE_1__utils_auth__["c" /* getUser */],
		profile: function profile() {
			__WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push({
				name: "Profile"
			});
		},
		logout: function logout() {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_auth__["a" /* endSession */])();
		}
	}
});

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_analysis_Line__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_analysis_Bar__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_store__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_auth__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "analysis",
	data: function data() {
		return {
			app: __WEBPACK_IMPORTED_MODULE_3__utils_store__["a" /* default */]
		};
	},

	components: {
		LineChart: __WEBPACK_IMPORTED_MODULE_0__components_analysis_Line__["a" /* default */],
		BarChart: __WEBPACK_IMPORTED_MODULE_1__components_analysis_Bar__["a" /* default */]
	},
	created: function created() {
		var _self = this;
		__WEBPACK_IMPORTED_MODULE_5_axios___default()({
			method: "get",
			url: __WEBPACK_IMPORTED_MODULE_2__config__["b" /* REPORT_URL */],
			headers: {
				Authorization: "Bearer " + __WEBPACK_IMPORTED_MODULE_4__utils_auth__["b" /* getToken */]()
			}
		}).then(function (response) {
			__WEBPACK_IMPORTED_MODULE_4__utils_auth__["f" /* setToken */](response.headers["x-new-token"]);
			return _self.app.entries = response.data;
		}).catch(function (error) {
			__WEBPACK_IMPORTED_MODULE_4__utils_auth__["f" /* setToken */](error.response.headers["x-new-token"]);
			try {
				__WEBPACK_IMPORTED_MODULE_4__utils_auth__["g" /* checkAuth */](error);
			} catch (e) {
				return _self.app.messages = ["Unable to load your data."];
			}
		});
	},

	computed: {
		distanceDriven: function distanceDriven() {
			var dd = {
				label: "Distance Driven",
				fill: false,
				borderColor: "#5A7C9F",
				backgroundColor: "#5A7C9F",
				data: [],
				yAxisID: "y-axis-2"
			};
			for (var entry in this.app.entries) {
				dd.data.push(this.app.entries[entry].distance_driven);
			}
			return dd;
		},
		hydrogenFuelled: function hydrogenFuelled() {
			var chartData = {
				labels: [],
				datasets: []
			};
			var dataset = {
				label: "Hydrogen Fuelled",
				borderColor: "#35495E",
				backgroundColor: "#35495E",
				fill: false,
				data: [],
				yAxisID: "y-axis-1"
			};
			for (var entry in this.app.entries) {
				chartData.labels.push(this.app.entries[entry].label);
				dataset.data.push(this.app.entries[entry].hydrogen_fuelled.toFixed(2));
			}
			chartData.datasets.push(dataset, this.distanceDriven);
			return chartData;
		},
		cost: function cost() {
			var chartData = {
				labels: [],
				datasets: []
			};
			var dataset = {
				label: "Cost (" + this.app.loadCurrencySymbol(this.app.user.currency) + ")",
				borderColor: "#35495E",
				backgroundColor: "#35495E",
				fill: false,
				data: [],
				yAxisID: "y-axis-1"
			};
			for (var entry in this.app.entries) {
				chartData.labels.push(this.app.entries[entry].label);
				dataset.data.push(this.app.entries[entry].cost);
			}
			chartData.datasets.push(dataset, this.distanceDriven);
			return chartData;
		},
		electricityFuelled: function electricityFuelled() {
			var chartData = {
				labels: [],
				datasets: []
			};
			var dataset = {
				label: "Electricity Charged",
				borderColor: "#35495E",
				backgroundColor: "#35495E",
				fill: false,
				data: [],
				yAxisID: "y-axis-1"
			};
			for (var entry in this.app.entries) {
				chartData.labels.push(this.app.entries[entry].label);
				dataset.data.push(this.app.entries[entry].electricity_charged.toFixed(2));
			}
			chartData.datasets.push(dataset, this.distanceDriven);
			return chartData;
		},
		chartOptionsH: function chartOptionsH() {
			return {
				responsive: true,
				maintainAspectRatio: false,
				stacked: true,
				scales: {
					xAxes: [{
						scaleLabel: {
							display: true,
							labelString: "Date"
						},
						gridLines: {
							drawOnChartArea: true
						}
					}],
					yAxes: [{
						type: "linear",
						display: true,
						position: "left",
						id: "y-axis-1",
						gridLines: {
							drawOnChartArea: true
						},
						scaleLabel: {
							display: true,
							labelString: "Hydrogen Fuelled (KG)"
						}
					}, {
						type: "linear",
						display: true,
						position: "right",
						scaleLabel: {
							display: true,
							labelString: this.app.user.units
						},
						id: "y-axis-2"
					}]
				}
			};
		},
		chartOptionsE: function chartOptionsE() {
			return {
				responsive: true,
				maintainAspectRatio: false,
				stacked: true,
				scales: {
					xAxes: [{
						scaleLabel: {
							display: true,
							labelString: "Date"
						},
						gridLines: {
							drawOnChartArea: true
						}
					}],
					yAxes: [{
						type: "linear",
						display: true,
						position: "left",
						id: "y-axis-1",
						gridLines: {
							drawOnChartArea: true
						},
						scaleLabel: {
							display: true,
							labelString: "Electricity Charged (kWh)"
						}
					}, {
						type: "linear",
						display: true,
						position: "right",
						scaleLabel: {
							display: true,
							labelString: this.app.user.units
						},
						id: "y-axis-2"
					}]
				}
			};
		},
		chartOptionsC: function chartOptionsC() {
			return {
				responsive: true,
				maintainAspectRatio: false,
				stacked: true,
				scales: {
					xAxes: [{
						scaleLabel: {
							display: true,
							labelString: "Date"
						},
						gridLines: {
							drawOnChartArea: true
						}
					}],
					yAxes: [{
						type: "linear",
						display: true,
						position: "left",
						id: "y-axis-1",
						gridLines: {
							drawOnChartArea: true
						},
						scaleLabel: {
							display: true,
							labelString: "Cost (" + this.app.loadCurrencySymbol(this.app.user.currency) + ")"
						}
					}, {
						type: "linear",
						display: true,
						position: "right",
						scaleLabel: {
							display: true,
							labelString: this.app.user.units
						},
						id: "y-axis-2"
					}]
				}
			};
		}
	}
});

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_auth__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_store__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_validators__ = __webpack_require__(104);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
	name: "dashboard",
	data: function data() {
		return {
			app: __WEBPACK_IMPORTED_MODULE_4__utils_store__["a" /* default */],
			local: {
				refuelling_amount: "",
				odometer_reading: "",
				price: "",
				refueled_at: new Date(),
				refuelling_station_location: "",
				electricity_amount: __WEBPACK_IMPORTED_MODULE_4__utils_store__["a" /* default */].user.vehicle_model === "Symbio" ? null : 0,
				notes: ""
			}
		};
	},

	validations: {
		local: {
			refuelling_amount: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
				decimal: __WEBPACK_IMPORTED_MODULE_7__utils_validators__["a" /* decimal */],
				maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(8)
			},
			electricity_amount: {
				required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["requiredIf"])(function () {
					return __WEBPACK_IMPORTED_MODULE_4__utils_store__["a" /* default */].user.vehicle_model === "Symbio";
				}),
				decimal: __WEBPACK_IMPORTED_MODULE_7__utils_validators__["a" /* decimal */],
				maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(8)
			},
			odometer_reading: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
				numeric: __WEBPACK_IMPORTED_MODULE_7__utils_validators__["b" /* numeric */]
			},
			price: {
				decimal: __WEBPACK_IMPORTED_MODULE_7__utils_validators__["a" /* decimal */],
				maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(6)
			}
		}
	},
	methods: {
		addEntry: function addEntry() {
			var _self = this;
			var data = _.assign({}, this.local);
			data.user_id = _self.app.credentials.sub;
			__WEBPACK_IMPORTED_MODULE_1_axios___default()({
				method: "post",
				url: __WEBPACK_IMPORTED_MODULE_6__config__["c" /* INPUT_URL */],
				data: data,
				headers: {
					Authorization: "Bearer " + __WEBPACK_IMPORTED_MODULE_2__utils_auth__["b" /* getToken */]()
				}
			}).then(function (response) {
				__WEBPACK_IMPORTED_MODULE_2__utils_auth__["f" /* setToken */](response.headers["x-new-token"]);
				_self.local = _.assign({}, _self.app.temp.refueling);
				_self.app.messages.push("This refuel has beeen registered.");
				window.scrollTo(0, 0);
				_self.$v.local.$reset();
			}).catch(function (error) {
				__WEBPACK_IMPORTED_MODULE_2__utils_auth__["f" /* setToken */](error.response.headers["x-new-token"]);
				try {
					__WEBPACK_IMPORTED_MODULE_2__utils_auth__["g" /* checkAuth */](error);
				} catch (e) {}
			});
		}
	}
});

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_auth__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_store__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_validators__ = __webpack_require__(104);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
	name: "edit-entry",
	data: function data() {
		return {
			app: __WEBPACK_IMPORTED_MODULE_4__utils_store__["a" /* default */],
			local: {
				refuelling_amount: "",
				odometer_reading: "",
				price: "",
				refueled_at: new Date(),
				refuelling_station_location: "",
				electricity_amount: null,
				notes: ""
			}
		};
	},

	validations: {
		local: {
			refuelling_amount: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
				decimal: __WEBPACK_IMPORTED_MODULE_7__utils_validators__["a" /* decimal */],
				maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(8)
			},
			electricity_amount: {
				required: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["requiredIf"])(function () {
					return __WEBPACK_IMPORTED_MODULE_4__utils_store__["a" /* default */].user.vehicle_model === "Symbio";
				}),
				decimal: __WEBPACK_IMPORTED_MODULE_7__utils_validators__["a" /* decimal */],
				maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(8)
			},
			odometer_reading: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
				numeric: __WEBPACK_IMPORTED_MODULE_7__utils_validators__["b" /* numeric */]
			},
			price: {
				decimal: __WEBPACK_IMPORTED_MODULE_7__utils_validators__["a" /* decimal */],
				maxLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["maxLength"])(6)
			}
		}
	},
	computed: {
		currentEntry: function currentEntry() {
			return this.$route.params.id;
		}
	},
	created: function created() {
		this.getEntry();
	},

	methods: {
		showConfirmDelete: function showConfirmDelete() {
			var _this = this;

			this.$confirm("This will permanently delete the entry. Continue?", "Delete entry?", {
				confirmButtonText: "OK",
				cancelButtonText: "Cancel",
				type: "warning"
			}).then(function () {
				_this.deleteEntry();
			}).catch(function () {});
		},
		getEntry: function getEntry() {
			var _self = this;
			__WEBPACK_IMPORTED_MODULE_1_axios___default()({
				method: "get",
				url: __WEBPACK_IMPORTED_MODULE_6__config__["b" /* REPORT_URL */] + "/" + _self.currentEntry,
				headers: {
					Authorization: "Bearer " + __WEBPACK_IMPORTED_MODULE_2__utils_auth__["b" /* getToken */]()
				}
			}).then(function (response) {
				__WEBPACK_IMPORTED_MODULE_2__utils_auth__["f" /* setToken */](response.headers["x-new-token"]);
				return _self.local = _.assign({}, _self.local, response.data);
			}).catch(function (error) {
				__WEBPACK_IMPORTED_MODULE_2__utils_auth__["f" /* setToken */](error.response.headers["x-new-token"]);
				try {
					__WEBPACK_IMPORTED_MODULE_2__utils_auth__["g" /* checkAuth */](error);
				} catch (e) {}
				if (error.response.status === 404) {
					__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push("/history");
					return _self.app.messages.push("This entry does not exist.");
				} else {
					__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push("/history");
					return _self.app.messages.push("You don't have access to this entry");
				}
			});
		},
		deleteEntry: function deleteEntry() {
			var _self = this;

			return __WEBPACK_IMPORTED_MODULE_1_axios___default()({
				method: "delete",
				url: __WEBPACK_IMPORTED_MODULE_6__config__["b" /* REPORT_URL */] + "/" + _self.currentEntry,
				headers: {
					Authorization: "Bearer " + __WEBPACK_IMPORTED_MODULE_2__utils_auth__["b" /* getToken */]()
				}
			}).then(function (response) {
				__WEBPACK_IMPORTED_MODULE_2__utils_auth__["f" /* setToken */](response.headers["x-new-token"]);
				__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push("/history");
				return _self.app.messages.push("This refuel has now been deleted.");
			}).catch(function (error) {
				__WEBPACK_IMPORTED_MODULE_2__utils_auth__["f" /* setToken */](error.response.headers["x-new-token"]);
				try {
					__WEBPACK_IMPORTED_MODULE_2__utils_auth__["g" /* checkAuth */](error);
				} catch (e) {}
			});
		},
		updateEntry: function updateEntry() {
			var _self = this;
			var data = _.assign({}, this.local);
			__WEBPACK_IMPORTED_MODULE_1_axios___default()({
				method: "put",
				url: __WEBPACK_IMPORTED_MODULE_6__config__["b" /* REPORT_URL */] + "/" + _self.currentEntry,
				data: data,
				headers: {
					Authorization: "Bearer " + __WEBPACK_IMPORTED_MODULE_2__utils_auth__["b" /* getToken */]()
				}
			}).then(function (response) {
				__WEBPACK_IMPORTED_MODULE_2__utils_auth__["f" /* setToken */](response.headers["x-new-token"]);
				_self.local = _.assign({}, _self.app.temp.refueling);
				__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push("/history");
				return _self.app.messages.push("This refuel has now been updated.");
			}).catch(function (error) {
				__WEBPACK_IMPORTED_MODULE_2__utils_auth__["f" /* setToken */](error.response.headers["x-new-token"]);
				try {
					__WEBPACK_IMPORTED_MODULE_2__utils_auth__["g" /* checkAuth */](error);
				} catch (e) {}
			});
		}
	}
});

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_format__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns_format__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_store__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_auth__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	name: "history",
	data: function data() {
		return {
			app: __WEBPACK_IMPORTED_MODULE_2__utils_store__["a" /* default */],
			showArea: 0
		};
	},

	methods: {
		formatDate: function formatDate(date) {
			return __WEBPACK_IMPORTED_MODULE_0_date_fns_format___default()(date, "Do MMMM, h:mma");
		},
		showTab: function showTab(tabIndex) {
			this.showArea = "showArea-" + tabIndex;
			this.activeTab(tabIndex);
			return window.scrollTo(0, 0);
		},
		activeTab: function activeTab(tabIndex) {
			return this.showArea === "showArea-" + tabIndex;
		},
		generateTitle: function generateTitle(entry) {
			var elecFuelled = this.app.user.vehicle_model === "Symbio" ? " - Total electricity charged: " + entry.electricity_charged + "kWh " : "";
			var hydText = "Total hydrogen fuelled: " + entry.hydrogen_fuelled + "kg";
			var disText = " - Total distance: " + entry.distance_driven.toLocaleString() + " " + this.app.user.units;
			return entry.label + " <small class=\"info\">( " + hydText + elecFuelled + disText + " )</small>";
		}
	},
	created: function created() {
		var _self = this;
		__WEBPACK_IMPORTED_MODULE_4_axios___default()({
			method: "get",
			url: __WEBPACK_IMPORTED_MODULE_1__config__["b" /* REPORT_URL */],
			headers: {
				Authorization: "Bearer " + __WEBPACK_IMPORTED_MODULE_3__utils_auth__["b" /* getToken */]()
			}
		}).then(function (response) {
			__WEBPACK_IMPORTED_MODULE_3__utils_auth__["f" /* setToken */](response.headers["x-new-token"]);
			return _self.app.entries = response.data;
		}).catch(function (error) {
			__WEBPACK_IMPORTED_MODULE_3__utils_auth__["f" /* setToken */](error.response.headers["x-new-token"]);
			try {
				__WEBPACK_IMPORTED_MODULE_3__utils_auth__["g" /* checkAuth */](error);
			} catch (e) {
				return _self.app.messages = ["Unable to load your data."];
			}
		});
	}
});

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_auth__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_store__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
	name: "profile",
	data: function data() {
		return {
			app: __WEBPACK_IMPORTED_MODULE_4__utils_store__["a" /* default */],
			credentials: {
				first_name: "",
				last_name: "",
				email: "",
				location: "",
				currency: "",
				units: "",
				password: "",
				repeatPassword: ""
			},
			options: [{
				value: "Toyota Mirai",
				option: "Toyota Mirai"
			}, {
				value: "Hyundai ix35",
				option: "Hyundai ix35"
			}, {
				value: "Honda Clarity",
				option: "Honda Clarity"
			}, {
				value: "Symbio",
				option: "Symbio"
			}, {
				value: "Other",
				option: "Other"
			}]
		};
	},

	validations: {
		credentials: {
			first_name: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
				minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(3)
			},
			last_name: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
				minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(3)
			},
			email: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
				email: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["email"]
			},
			location: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
				minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(4)
			},
			password: {
				minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(6)
			},
			repeatPassword: {
				sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["sameAs"])("password")
			}
		}
	},
	computed: {
		first_name: {
			get: function get() {
				return this.credentials.first_name = this.app.user.first_name;
			},
			set: function set(newValue) {
				this.credentials.first_name = newValue;
			}
		},
		last_name: {
			get: function get() {
				return this.credentials.last_name = this.app.user.last_name;
			},
			set: function set(newValue) {
				this.credentials.last_name = newValue;
			}
		},
		email: {
			get: function get() {
				return this.credentials.email = this.app.user.email;
			},
			set: function set(newValue) {
				this.credentials.email = newValue;
			}
		},
		location: {
			get: function get() {
				return this.credentials.location = this.app.user.location;
			},
			set: function set(newValue) {
				this.credentials.location = newValue;
			}
		},
		currency: {
			get: function get() {
				return this.credentials.currency = this.app.user.currency;
			},
			set: function set(newValue) {
				if (this.app.user.currency !== newValue) {
					this.app.user.currency = newValue;
				}
				this.credentials.currency = newValue;
			}
		},
		units: {
			get: function get() {
				return this.credentials.units = this.app.user.units;
			},
			set: function set(newValue) {
				if (this.app.user.units !== newValue) {
					this.app.user.units = newValue;
				}
				this.credentials.units = newValue;
			}
		}
	},
	methods: {
		getToken: __WEBPACK_IMPORTED_MODULE_2__utils_auth__["b" /* getToken */],
		update: function update() {
			if (this.$v.$invalid) return;
			var _self = this;
			__WEBPACK_IMPORTED_MODULE_1_axios___default()({
				method: "put",
				url: __WEBPACK_IMPORTED_MODULE_5__config__["d" /* PROFILE_URL */],
				data: this.$data.credentials,
				headers: {
					Authorization: "Bearer " + __WEBPACK_IMPORTED_MODULE_2__utils_auth__["b" /* getToken */]()
				}
			}).then(function (response) {
				window.scrollTo(0, 0);
				__WEBPACK_IMPORTED_MODULE_2__utils_auth__["f" /* setToken */](response.headers["x-new-token"]);
				__WEBPACK_IMPORTED_MODULE_2__utils_auth__["h" /* setUser */](response.data);
				return _self.app.messages = ["Your details have now been updated"];
			}).catch(function (error) {
				var response = error.response;
				__WEBPACK_IMPORTED_MODULE_2__utils_auth__["f" /* setToken */](response.headers["x-new-token"]);
				return _self.app.messages = [response.data.message];
			});
		}
	}
});

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
	name: "terms"
});

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_auth__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_store__ = __webpack_require__(8);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
	name: "login",
	data: function data() {
		return {
			app: __WEBPACK_IMPORTED_MODULE_5__utils_store__["a" /* default */],
			credentials: {
				email: "",
				password: ""
			}
		};
	},

	validations: {
		credentials: {
			email: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
				email: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["email"]
			},
			password: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
			}
		}
	},
	methods: {
		login: function login() {
			if (this.$v.$invalid) return;
			var _self = this;
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__config__["i" /* LOGIN_URL */], this.$data.credentials).then(function (response) {
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_auth__["f" /* setToken */])(response.data.token);
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_auth__["h" /* setUser */])(response.data.user);
				return __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/dashboard");
			}).catch(function (error) {
				console.log(error.response);
				var res = error.response;
				return _self.app.messages = [res.data.message];
			});
		}
	}
});

/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_auth__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_store__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
	name: "login",
	data: function data() {
		return {
			app: __WEBPACK_IMPORTED_MODULE_4__utils_store__["a" /* default */],
			credentials: {
				first_name: "",
				last_name: "",
				email: "",
				location: "",
				vin_chassis_no: "",
				vehicle_model: "Toyota Mirai",
				odometer_reading: 0,
				currency: "EUR",
				units: "km",
				password: "",
				repeatPassword: ""
			},
			options: [{
				value: "Toyota Mirai",
				option: "Toyota Mirai"
			}, {
				value: "Hyundai ix35",
				option: "Hyundai ix35"
			}, {
				value: "Honda Clarity",
				option: "Honda Clarity"
			}, {
				value: "Symbio",
				option: "Symbio"
			}, {
				value: "Other",
				option: "Other"
			}]
		};
	},

	validations: {
		credentials: {
			first_name: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
				minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(3)
			},
			last_name: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
				minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(3)
			},
			email: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
				email: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["email"]
			},
			location: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
			},
			vin_chassis_no: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
				alphaNum: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["alphaNum"],
				minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(5)
			},
			vehicle_model: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
			},
			odometer_reading: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
			},
			password: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
				minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(6)
			},
			repeatPassword: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
				sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["sameAs"])("password")
			}
		}
	},
	methods: {
		getToken: __WEBPACK_IMPORTED_MODULE_2__utils_auth__["b" /* getToken */],
		register: function register() {
			if (this.$v.$invalid) return;
			var _self = this;
			__WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_5__config__["h" /* REGISTER_URL */], this.$data.credentials).then(function (response) {
				__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push("/");
				return _self.app.messages = ["Thank you for registering, " + response.data.first_name + " " + response.data.last_name + "! You can now login using the details you have just entered."];
			}).catch(function (error) {
				var response = error.response;
				if (response.status === 400) {
					return _self.app.messages = response.data.errors;
				}
				__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push("/");
				return _self.app.messages = [response.data.message];
			});
		}
	}
});

/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_store__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "reminder",
	data: function data() {
		return {
			app: __WEBPACK_IMPORTED_MODULE_3__utils_store__["a" /* default */],
			credentials: {
				email: ""
			}
		};
	},

	validations: {
		credentials: {
			email: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
				email: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["email"]
			}
		}
	},
	methods: {
		sendReminder: function sendReminder() {
			if (this.$v.$invalid) return;
			var _self = this;
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__config__["g" /* REMINDER_URL */], this.$data.credentials).then(function (response) {
				__WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/");
				return _self.app.messages = [response.data.message];
			}).catch(function (error) {
				var res = error.response;
				return _self.app.messages = [res.data.message];
			});
		}
	}
});

/***/ }),

/***/ 352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_store__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(10);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
	name: "reset",
	data: function data() {
		return {
			app: __WEBPACK_IMPORTED_MODULE_3__utils_store__["a" /* default */],
			credentials: {
				email: this.$route.query.email,
				token: this.$route.query.token,
				password: "",
				repeatPassword: ""
			}
		};
	},

	validations: {
		credentials: {
			email: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
				email: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["email"]
			},
			token: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
			},
			password: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
				minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["minLength"])(6)
			},
			repeatPassword: {
				required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
				sameAsPassword: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["sameAs"])("password")
			}
		}
	},
	computed: {
		validHash: function validHash() {
			var _self = this;
			if (!this.credentials.email || !this.credentials.token) return false;
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__config__["e" /* RESET_CHECK_URL */], {
				email: this.credentials.email,
				token: this.credentials.token
			}).then(function (response) {
				return true;
			}).catch(function (error) {
				var res = error.response;
				__WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/");
				return _self.app.messages = [res.data.message];
			});
		}
	},
	methods: {
		resetPassword: function resetPassword() {
			if (this.$v.$invalid) return;
			var _self = this;
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__config__["f" /* RESET_URL */], {
				email: this.credentials.email,
				token: this.credentials.token,
				password: this.credentials.password,
				password_confirmation: this.credentials.repeatPassword
			}).then(function (response) {
				__WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push("/");
				return _self.app.messages = [response.data.message];
			}).catch(function (error) {
				var res = error.response;
				return _self.app.messages = [res.data.message];
			});
		}
	}
});

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 466:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 467:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 468:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 469:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 470:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 471:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 472:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 176,
	"./af.js": 176,
	"./ar": 183,
	"./ar-dz": 177,
	"./ar-dz.js": 177,
	"./ar-kw": 178,
	"./ar-kw.js": 178,
	"./ar-ly": 179,
	"./ar-ly.js": 179,
	"./ar-ma": 180,
	"./ar-ma.js": 180,
	"./ar-sa": 181,
	"./ar-sa.js": 181,
	"./ar-tn": 182,
	"./ar-tn.js": 182,
	"./ar.js": 183,
	"./az": 184,
	"./az.js": 184,
	"./be": 185,
	"./be.js": 185,
	"./bg": 186,
	"./bg.js": 186,
	"./bn": 187,
	"./bn.js": 187,
	"./bo": 188,
	"./bo.js": 188,
	"./br": 189,
	"./br.js": 189,
	"./bs": 190,
	"./bs.js": 190,
	"./ca": 191,
	"./ca.js": 191,
	"./cs": 192,
	"./cs.js": 192,
	"./cv": 193,
	"./cv.js": 193,
	"./cy": 194,
	"./cy.js": 194,
	"./da": 195,
	"./da.js": 195,
	"./de": 198,
	"./de-at": 196,
	"./de-at.js": 196,
	"./de-ch": 197,
	"./de-ch.js": 197,
	"./de.js": 198,
	"./dv": 199,
	"./dv.js": 199,
	"./el": 200,
	"./el.js": 200,
	"./en-au": 201,
	"./en-au.js": 201,
	"./en-ca": 202,
	"./en-ca.js": 202,
	"./en-gb": 203,
	"./en-gb.js": 203,
	"./en-ie": 204,
	"./en-ie.js": 204,
	"./en-nz": 205,
	"./en-nz.js": 205,
	"./eo": 206,
	"./eo.js": 206,
	"./es": 208,
	"./es-do": 207,
	"./es-do.js": 207,
	"./es.js": 208,
	"./et": 209,
	"./et.js": 209,
	"./eu": 210,
	"./eu.js": 210,
	"./fa": 211,
	"./fa.js": 211,
	"./fi": 212,
	"./fi.js": 212,
	"./fo": 213,
	"./fo.js": 213,
	"./fr": 216,
	"./fr-ca": 214,
	"./fr-ca.js": 214,
	"./fr-ch": 215,
	"./fr-ch.js": 215,
	"./fr.js": 216,
	"./fy": 217,
	"./fy.js": 217,
	"./gd": 218,
	"./gd.js": 218,
	"./gl": 219,
	"./gl.js": 219,
	"./gom-latn": 220,
	"./gom-latn.js": 220,
	"./he": 221,
	"./he.js": 221,
	"./hi": 222,
	"./hi.js": 222,
	"./hr": 223,
	"./hr.js": 223,
	"./hu": 224,
	"./hu.js": 224,
	"./hy-am": 225,
	"./hy-am.js": 225,
	"./id": 226,
	"./id.js": 226,
	"./is": 227,
	"./is.js": 227,
	"./it": 228,
	"./it.js": 228,
	"./ja": 229,
	"./ja.js": 229,
	"./jv": 230,
	"./jv.js": 230,
	"./ka": 231,
	"./ka.js": 231,
	"./kk": 232,
	"./kk.js": 232,
	"./km": 233,
	"./km.js": 233,
	"./kn": 234,
	"./kn.js": 234,
	"./ko": 235,
	"./ko.js": 235,
	"./ky": 236,
	"./ky.js": 236,
	"./lb": 237,
	"./lb.js": 237,
	"./lo": 238,
	"./lo.js": 238,
	"./lt": 239,
	"./lt.js": 239,
	"./lv": 240,
	"./lv.js": 240,
	"./me": 241,
	"./me.js": 241,
	"./mi": 242,
	"./mi.js": 242,
	"./mk": 243,
	"./mk.js": 243,
	"./ml": 244,
	"./ml.js": 244,
	"./mr": 245,
	"./mr.js": 245,
	"./ms": 247,
	"./ms-my": 246,
	"./ms-my.js": 246,
	"./ms.js": 247,
	"./my": 248,
	"./my.js": 248,
	"./nb": 249,
	"./nb.js": 249,
	"./ne": 250,
	"./ne.js": 250,
	"./nl": 252,
	"./nl-be": 251,
	"./nl-be.js": 251,
	"./nl.js": 252,
	"./nn": 253,
	"./nn.js": 253,
	"./pa-in": 254,
	"./pa-in.js": 254,
	"./pl": 255,
	"./pl.js": 255,
	"./pt": 257,
	"./pt-br": 256,
	"./pt-br.js": 256,
	"./pt.js": 257,
	"./ro": 258,
	"./ro.js": 258,
	"./ru": 259,
	"./ru.js": 259,
	"./sd": 260,
	"./sd.js": 260,
	"./se": 261,
	"./se.js": 261,
	"./si": 262,
	"./si.js": 262,
	"./sk": 263,
	"./sk.js": 263,
	"./sl": 264,
	"./sl.js": 264,
	"./sq": 265,
	"./sq.js": 265,
	"./sr": 267,
	"./sr-cyrl": 266,
	"./sr-cyrl.js": 266,
	"./sr.js": 267,
	"./ss": 268,
	"./ss.js": 268,
	"./sv": 269,
	"./sv.js": 269,
	"./sw": 270,
	"./sw.js": 270,
	"./ta": 271,
	"./ta.js": 271,
	"./te": 272,
	"./te.js": 272,
	"./tet": 273,
	"./tet.js": 273,
	"./th": 274,
	"./th.js": 274,
	"./tl-ph": 275,
	"./tl-ph.js": 275,
	"./tlh": 276,
	"./tlh.js": 276,
	"./tr": 277,
	"./tr.js": 277,
	"./tzl": 278,
	"./tzl.js": 278,
	"./tzm": 280,
	"./tzm-latn": 279,
	"./tzm-latn.js": 279,
	"./tzm.js": 280,
	"./uk": 281,
	"./uk.js": 281,
	"./ur": 282,
	"./ur.js": 282,
	"./uz": 284,
	"./uz-latn": 283,
	"./uz-latn.js": 283,
	"./uz.js": 284,
	"./vi": 285,
	"./vi.js": 285,
	"./x-pseudo": 286,
	"./x-pseudo.js": 286,
	"./yo": 287,
	"./yo.js": 287,
	"./zh-cn": 288,
	"./zh-cn.js": 288,
	"./zh-hk": 289,
	"./zh-hk.js": 289,
	"./zh-tw": 290,
	"./zh-tw.js": 290
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 601;

/***/ }),

/***/ 603:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTEycHgiIGhlaWdodD0iNTEycHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0Ni4yICg0NDQ5NikgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+R3JvdXA8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iQXJ0Ym9hcmQiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAiPgogICAgICAgICAgICAgICAgPGcgaWQ9ImJhY2tncm91bmQiPgogICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJSZWN0YW5nbGUiIGZpbGw9IiM1MEJGRkYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI1Ni4wMDAwMDAsIDI1Ni4wMDAwMDApIHNjYWxlKC0xLCAtMSkgdHJhbnNsYXRlKC0yNTYuMDAwMDAwLCAtMjU2LjAwMDAwMCkgIiBwb2ludHM9IjAgMCA1MTIgNTEyIDAgNTEyIj48L3BvbHlnb24+CiAgICAgICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlJlY3RhbmdsZSIgZmlsbD0iIzVBN0M5RiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjU2LjAwMDAwMCwgMjU2LjAwMDAwMCkgc2NhbGUoLTEsIDEpIHRyYW5zbGF0ZSgtMjU2LjAwMDAwMCwgLTI1Ni4wMDAwMDApICIgcG9pbnRzPSIwIDAgNTEyIDUxMiAwIDUxMiI+PC9wb2x5Z29uPgogICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJSZWN0YW5nbGUiIGZpbGw9IiMzNTQ5NUUiIHBvaW50cz0iMCAwIDUxMiA1MTIgMCA1MTIiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik05Mi45OTY5NTMyLDIyMi4zMjYzNzkgTDU5LjYyNzU2NDcsMjIyLjMyNjM3OSBMNTkuNjI3NTY0NywxODkuODc4Nzk3IEwxNjYuOTI1ODIsMTg5Ljg3ODc5NyBMMTY2LjkyNTgyLDIyMi4zMjYzNzkgTDEzMy41NTY0MzEsMjIyLjMyNjM3OSBMMTMzLjU1NjQzMSwzMjEuMTQ0MDE2IEw5Mi45OTY5NTMyLDMyMS4xNDQwMTYgTDkyLjk5Njk1MzIsMjIyLjMyNjM3OSBaIE0xODAuOTM3Mjc2LDE4OS44Nzg3OTcgTDIzNy45MDQ5MDYsMTg5Ljg3ODc5NyBMMjU0Ljg2NjE0MiwyNzkuNDc4MzcxIEwyNTUuMjM0ODY1LDI3OS40NzgzNzEgTDI3My40ODY2MywxODkuODc4Nzk3IEwzMjguNzk1MDA4LDE4OS44Nzg3OTcgTDMyOC43OTUwMDgsMzIxLjE0NDAxNiBMMjkxLjkyMjc1NiwzMjEuMTQ0MDE2IEwyOTEuOTIyNzU2LDIyOC41OTQ2NjIgTDI5MS41NTQwMzMsMjI4LjU5NDY2MiBMMjcyLjAxMTc0LDMyMS4xNDQwMTYgTDIzOC4wODkyNjcsMzIxLjE0NDAxNiBMMjE4LjE3ODI1MSwyMjguNTk0NjYyIEwyMTcuODA5NTI4LDIyOC41OTQ2NjIgTDIxNy44MDk1MjgsMzIxLjE0NDAxNiBMMTgwLjkzNzI3NiwzMjEuMTQ0MDE2IEwxODAuOTM3Mjc2LDE4OS44Nzg3OTcgWiBNMzUxLjY1NTgwNSwxODkuODc4Nzk3IEw0NTEuMzk1MjQ4LDE4OS44Nzg3OTcgTDQ1MS4zOTUyNDgsMjE5Ljc0NTMyMSBMMzkyLjIxNTI4MywyMTkuNzQ1MzIxIEwzOTIuMjE1MjgzLDI0Mi4wNTMwMzQgTDQ0Ny4zMzkzMDEsMjQyLjA1MzAzNCBMNDQ3LjMzOTMwMSwyNzEuNTUwODM2IEwzOTIuMjE1MjgzLDI3MS41NTA4MzYgTDM5Mi4yMTUyODMsMzIxLjE0NDAxNiBMMzUxLjY1NTgwNSwzMjEuMTQ0MDE2IEwzNTEuNjU1ODA1LDE4OS44Nzg3OTcgWiIgaWQ9IlRNRiIgZmlsbD0iI0ZGRkZGRiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjU1LjUxMTQwNiwgMjU1LjUxMTQwNikgcm90YXRlKC00NS4wMDAwMDApIHRyYW5zbGF0ZSgtMjU1LjUxMTQwNiwgLTI1NS41MTE0MDYpICI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ 616:
/***/ (function(module, exports) {

module.exports = {"name":"vue-chartjs","version":"2.8.2","description":"vue.js wrapper for chart.js","author":"Jakub Juszczak <jakub@posteo.de>","homepage":"http://vue-chartjs.org","license":"MIT","contributors":[{"name":"Thorsten Lünborg","web":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","web":"https://github.com/jcalonso"}],"maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","web":"http://www.jakubjuszczak.de"}],"repository":{"type":"git","url":"git+ssh://git@github.com:apertureless/vue-chartjs.git"},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"main":"dist/vue-chartjs.js","unpkg":"dist/vue-chartjs.full.min.js","module":"es/index.js","jsnext:main":"es/index.js","files":["src","dist","es"],"scripts":{"dev":"node build/dev-server.js","build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","unit":"karma start test/unit/karma.conf.js --single-run","e2e":"node test/e2e/runner.js","test":"npm run unit","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","prepublish":"yarn run lint && yarn run test && yarn run build"},"dependencies":{"lodash":"^4.17.4"},"peerDependencies":{"chart.js":"^2.6.0","vue":"^2.4.2"},"devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.6.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.2","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]}}

/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(472)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(635),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(470)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(633),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(471)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(634),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(465)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(627),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2a9ad854",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(467)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(629),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(637),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(468)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(631),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4b5c2aa0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(466)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(628),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(630),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(636),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 627:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container--wide"
  }, [(_vm.app.entries.length) ? _c('div', [_vm._m(0), _vm._v(" "), _c('el-collapse', {
    attrs: {
      "accordion": ""
    },
    model: {
      value: (_vm.showArea),
      callback: function($$v) {
        _vm.showArea = $$v
      },
      expression: "showArea"
    }
  }, _vm._l((_vm.app.entries), function(entry, index) {
    return _c('el-collapse-item', {
      key: index,
      attrs: {
        "name": index
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.generateTitle(entry))
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "responsive-table"
    }, [_c('table', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('thead', [_c('th', [_vm._v("Refuelling amount")]), _vm._v(" "), _c('th', [_vm._v("Odometer reading")]), _vm._v(" "), _c('th', [_vm._v("Price")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v(" ")])]), _vm._v(" "), _vm._l((entry.entries), function(item, itemIndex) {
      return _c('tr', {
        key: item.id
      }, [_c('td', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.refuelling_amount) + "kg\n\t\t\t\t\t\t\t\t"), (_vm.app.user.vehicle_model === 'Symbio') ? _c('span', [_vm._v("and " + _vm._s(item.electricity_amount) + "kWh")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.odometer_reading.toLocaleString()) + " " + _vm._s(_vm.app.user.units))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.app.loadCurrencySymbol(_vm.app.user.currency)) + _vm._s(item.price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(item.refueled_at)))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "text-align": "right"
        }
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'edit-entry',
            params: {
              id: item.id
            }
          },
          "tag": "el-button"
        }
      }, [_c('i', {
        staticClass: "el-icon-edit"
      })])], 1)])
    })], 2)])], 2)
  }))], 1) : _c('div', [_c('h1', [_vm._v("You currently don't have any entries to view.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("You will be able to manage all your previous entries for the past 12 months from this page.")]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dashboard'
      },
      "tag": "el-button"
    }
  }, [_vm._v("\n\t\t\t\tAdd entry\n\t\t\t")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_vm._v("Refuelling History "), _c('br'), _vm._v(" "), _c('small', {
    staticStyle: {
      "font-size": ".5em"
    }
  }, [_vm._v("For the past 12 months")])])
}]}

/***/ }),

/***/ 628:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top",
      "label-width": "100px"
    }
  }, [_c('h1', [_vm._v("Register")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "First name:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Your first name",
      "type": "text",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.first_name.$touch()
      }
    },
    model: {
      value: (_vm.credentials.first_name),
      callback: function($$v) {
        _vm.credentials.first_name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.first_name"
    }
  }), _vm._v(" "), (_vm.$v.credentials.first_name.$error) ? _c('span', [(!_vm.$v.credentials.first_name.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.first_name.minLength) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("First Name must have at least " + _vm._s(_vm.$v.credentials.first_name.$params.minLength.min) + " letters.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Last name:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Your last name",
      "type": "text",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.last_name.$touch()
      }
    },
    model: {
      value: (_vm.credentials.last_name),
      callback: function($$v) {
        _vm.credentials.last_name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.last_name"
    }
  }), _vm._v(" "), (_vm.$v.credentials.last_name.$error) ? _c('span', [(!_vm.$v.credentials.last_name.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.last_name.minLength) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Last Name must have at least " + _vm._s(_vm.$v.credentials.last_name.$params.minLength.min) + " letters.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Location:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Your location",
      "type": "text",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.location.$touch()
      }
    },
    model: {
      value: (_vm.credentials.location),
      callback: function($$v) {
        _vm.credentials.location = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.location"
    }
  }), _vm._v(" "), (_vm.$v.credentials.location.$error) ? _c('span', [(!_vm.$v.credentials.location.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Your email",
      "type": "email",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.email.$touch()
      }
    },
    model: {
      value: (_vm.credentials.email),
      callback: function($$v) {
        _vm.credentials.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.email"
    }
  }), _vm._v(" "), (_vm.$v.credentials.email.$error) ? _c('span', [(!_vm.$v.credentials.email.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.email.email) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Must be a valid email.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "VIN Number:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Your first name",
      "type": "text",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.vin_chassis_no.$touch()
      }
    },
    model: {
      value: (_vm.credentials.vin_chassis_no),
      callback: function($$v) {
        _vm.credentials.vin_chassis_no = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.vin_chassis_no"
    }
  }), _vm._v(" "), (_vm.$v.credentials.vin_chassis_no.$error) ? _c('span', [(!_vm.$v.credentials.vin_chassis_no.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.vin_chassis_no.minLength) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("VIN Number must have at least " + _vm._s(_vm.$v.credentials.vin_chassis_no.$params.minLength.min) + " letters.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.vin_chassis_no.alphaNum) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("VIN Number can only container letters and numbers.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Vehicle model:"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.app.isLoading
    },
    model: {
      value: (_vm.credentials.vehicle_model),
      callback: function($$v) {
        _vm.credentials.vehicle_model = $$v
      },
      expression: "credentials.vehicle_model"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  })), _vm._v(" "), (_vm.$v.credentials.vehicle_model.$error) ? _c('span', [(!_vm.$v.credentials.vehicle_model.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": 'Odometer Reading (' + _vm.credentials.units + '):'
    }
  }, [_c('el-input-number', {
    attrs: {
      "step": 1,
      "disabled": _vm.app.isLoading,
      "min": "0"
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.odometer_reading.$touch()
      }
    },
    model: {
      value: (_vm.credentials.odometer_reading),
      callback: function($$v) {
        _vm.credentials.odometer_reading = _vm._n($$v)
      },
      expression: "credentials.odometer_reading"
    }
  }), _vm._v(" "), (!_vm.$v.credentials.odometer_reading.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Currency:"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.app.isLoading
    },
    model: {
      value: (_vm.credentials.currency),
      callback: function($$v) {
        _vm.credentials.currency = $$v
      },
      expression: "credentials.currency"
    }
  }, _vm._l((_vm.app.currencySymbols), function(symbol, iso) {
    return _c('el-option', {
      key: iso,
      attrs: {
        "label": iso + ' (' + symbol + ')',
        "value": iso
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Prefered Units:"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.app.isLoading
    },
    model: {
      value: (_vm.credentials.units),
      callback: function($$v) {
        _vm.credentials.units = $$v
      },
      expression: "credentials.units"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "km"
    }
  }, [_vm._v("Kilometers")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "miles"
    }
  }, [_vm._v("Miles")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Password",
      "type": "password",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.password.$touch()
      }
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.credentials.password = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.password"
    }
  }), _vm._v(" "), (_vm.$v.credentials.password.$error) ? _c('span', [(!_vm.$v.credentials.password.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.password.minLength) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Email must have at least " + _vm._s(_vm.$v.credentials.password.$params.minLength.min) + " characters.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Repeat Password:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Password",
      "type": "password",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.repeatPassword.$touch()
      }
    },
    model: {
      value: (_vm.credentials.repeatPassword),
      callback: function($$v) {
        _vm.credentials.repeatPassword = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.repeatPassword"
    }
  }), _vm._v(" "), (_vm.$v.credentials.repeatPassword.$error) ? _c('span', [(!_vm.$v.credentials.repeatPassword.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.repeatPassword.sameAsPassword) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Passwords must be identical.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.$v.$invalid || _vm.app.isLoading,
      "loading": _vm.app.isLoading
    },
    on: {
      "click": function($event) {
        _vm.register()
      }
    }
  }, [_vm._v("\n\t\t\t\t\tRegister\n\t\t\t\t")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 629:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top",
      "label-width": "100px"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('small', [_vm._v("PROFILE")])]), _vm._v(" "), _c('h1', {
    staticStyle: {
      "margin-top": "0"
    }
  }, [_vm._v(_vm._s(_vm.app.user.first_name) + " " + _vm._s(_vm.app.user.last_name))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "First name:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Your first name",
      "type": "text",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.first_name.$touch()
      }
    },
    model: {
      value: (_vm.first_name),
      callback: function($$v) {
        _vm.first_name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "first_name"
    }
  }), _vm._v(" "), (_vm.$v.credentials.first_name.$error) ? _c('div', [_c('span', {
    staticClass: "el-form-item__error"
  }, [(!_vm.$v.credentials.first_name.required) ? _c('span', [_vm._v("This field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.first_name.minLength) ? _c('span', [_vm._v("First Name must have at least " + _vm._s(_vm.$v.credentials.first_name.$params.minLength.min) + " letters.")]) : _vm._e()])]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Last name:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Your last name",
      "type": "text",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.last_name.$touch()
      }
    },
    model: {
      value: (_vm.last_name),
      callback: function($$v) {
        _vm.last_name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "last_name"
    }
  }), _vm._v(" "), (_vm.$v.credentials.last_name.$error || _vm.$v.credentials.last_name.$invalid) ? _c('div', [_c('span', {
    staticClass: "el-form-item__error"
  }, [(!_vm.$v.credentials.last_name.required) ? _c('span', [_vm._v("This field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.last_name.minLength) ? _c('span', [_vm._v("First Name must have at least " + _vm._s(_vm.$v.credentials.last_name.$params.minLength.min) + " letters.")]) : _vm._e()])]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Location:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Your location",
      "type": "text",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.location.$touch()
      }
    },
    model: {
      value: (_vm.location),
      callback: function($$v) {
        _vm.location = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "location"
    }
  }), _vm._v(" "), (_vm.$v.credentials.location.$error) ? _c('div', [_c('span', {
    staticClass: "el-form-item__error"
  }, [(!_vm.$v.credentials.location.required) ? _c('span', [_vm._v("This field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.location.minLength) ? _c('span', [_vm._v("First Name must have at least " + _vm._s(_vm.$v.credentials.location.$params.minLength.min) + " letters.")]) : _vm._e()])]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Your email",
      "type": "email",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.email.$touch()
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "email"
    }
  }), _vm._v(" "), (_vm.$v.credentials.email.$error) ? _c('div', [_c('span', {
    staticClass: "el-form-item__error"
  }, [(!_vm.$v.credentials.email.required) ? _c('span', [_vm._v("This field is required.")]) : _vm._e(), (!_vm.$v.credentials.email.email) ? _c('span', [_vm._v("Must be a valid email.")]) : _vm._e()])]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "VIN Number:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Your first name",
      "type": "text",
      "disabled": true,
      "readonly": true
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.vin_chassis_no.$touch()
      }
    },
    model: {
      value: (_vm.app.user.vin_chassis_no),
      callback: function($$v) {
        _vm.app.user.vin_chassis_no = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "app.user.vin_chassis_no"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Vehicle model:"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": true,
      "readonly": true
    },
    model: {
      value: (_vm.app.user.vehicle_model),
      callback: function($$v) {
        _vm.app.user.vehicle_model = $$v
      },
      expression: "app.user.vehicle_model"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Currency:"
    }
  }, [_c('el-select', {
    attrs: {
      "disabled": _vm.app.isLoading
    },
    model: {
      value: (_vm.currency),
      callback: function($$v) {
        _vm.currency = $$v
      },
      expression: "currency"
    }
  }, _vm._l((_vm.app.currencySymbols), function(symbol, iso) {
    return _c('el-option', {
      key: iso,
      attrs: {
        "label": iso + ' (' + symbol + ')',
        "value": iso
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Prefered Units:"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.app.isLoading
    },
    model: {
      value: (_vm.units),
      callback: function($$v) {
        _vm.units = $$v
      },
      expression: "units"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "km"
    }
  }, [_vm._v("Kilometers")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "miles"
    }
  }, [_vm._v("Miles")])], 1)], 1), _vm._v(" "), _c('h3', [_vm._v("Security")]), _vm._v(" "), _c('p', [_c('small', [_vm._v("Leave this blank if you don't want to change you password.")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Password",
      "type": "password",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.password.$touch()
      }
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.credentials.password = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.password"
    }
  }), _vm._v(" "), (_vm.$v.credentials.password.$error) ? _c('span', [(!_vm.$v.credentials.password.minLength) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Email must have at least " + _vm._s(_vm.$v.credentials.password.$params.minLength.min) + " characters.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Repeat Password:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Password",
      "type": "password",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.repeatPassword.$touch()
      }
    },
    model: {
      value: (_vm.credentials.repeatPassword),
      callback: function($$v) {
        _vm.credentials.repeatPassword = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.repeatPassword"
    }
  }), _vm._v(" "), (_vm.$v.credentials.repeatPassword.$error) ? _c('span', [_c('span', {
    staticClass: "el-form-item__error"
  }, [(!_vm.$v.credentials.repeatPassword.requiredIfPassword) ? _c('span', [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.repeatPassword.sameAsPassword) ? _c('span', [_vm._v("Passwords must be identical.")]) : _vm._e()])]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.$v.$invalid || _vm.app.isLoading,
      "loading": _vm.app.isLoading
    },
    on: {
      "click": function($event) {
        _vm.update()
      }
    }
  }, [_vm._v("\n\t\t\t\t\tUpdate\n\t\t\t\t")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 630:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top",
      "label-width": "100px"
    }
  }, [_c('h1', [_vm._v("Reminder")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Your email address",
      "type": "email",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.email.$touch()
      }
    },
    model: {
      value: (_vm.credentials.email),
      callback: function($$v) {
        _vm.credentials.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.email"
    }
  }), _vm._v(" "), (_vm.$v.credentials.email.$error) ? _c('span', [(!_vm.$v.credentials.email.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("\n\t\t\t\t\t\tField is required.\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.email.email) ? _c('span', {
    staticClass: "el-form-item__error",
    attrs: {
      "disabled": _vm.app.isLoading
    }
  }, [_vm._v("\n\t\t\t\t\t\tMust be a valid email.\n\t\t\t\t\t")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.$v.$invalid || _vm.app.isLoading,
      "loading": _vm.app.isLoading
    },
    on: {
      "click": function($event) {
        _vm.sendReminder()
      }
    }
  }, [_vm._v("Send Reminder")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 631:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top",
      "label-width": "100px"
    }
  }, [_c('h1', [_vm._v("Login")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Email:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Your email address",
      "type": "email",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.email.$touch()
      }
    },
    model: {
      value: (_vm.credentials.email),
      callback: function($$v) {
        _vm.credentials.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.email"
    }
  }), _vm._v(" "), (_vm.$v.credentials.email.$error) ? _c('span', [(!_vm.$v.credentials.email.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.email.email) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Must be a valid email.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Your password",
      "type": "password",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.password.$touch()
      }
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.credentials.password = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.password"
    }
  }), _vm._v(" "), (_vm.$v.credentials.password.$error) ? _c('span', [(!_vm.$v.credentials.password.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.$v.$invalid,
      "loading": _vm.app.isLoading
    },
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('small', {
    staticClass: "links"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Register'
      }
    }
  }, [_vm._v("Register")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Reminder'
      }
    }
  }, [_vm._v("Forgot your password?")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(603),
      "alt": "Track My FCEV"
    }
  })]), _vm._v(" "), (_vm.app.isLoading) ? _c('i', {
    staticClass: "loading"
  }, [_c('i', {
    staticClass: "loading--internal"
  })]) : _vm._e(), _vm._v(" "), (_vm.getToken()) ? _c('div', [_c('el-dropdown', {
    attrs: {
      "trigger": "click"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.app.user.first_name) + " " + _vm._s(_vm.app.user.last_name) + " "), _c('i', {
    staticClass: "el-icon-caret-bottom el-icon--right"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    slot: "dropdown"
  }, [_c('li', {
    staticClass: "el-dropdown-menu__item",
    on: {
      "click": _vm.profile
    }
  }, [_vm._v("\n\t\t\t\t\t\tProfile\n\t\t\t\t\t")]), _vm._v(" "), _c('li', {
    staticClass: "el-dropdown-menu__item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("\n\t\t\t\t\t\tLogout\n\t\t\t\t\t")])])], 1)], 1) : _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Login'
      }
    }
  }, [_vm._v("Login")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Register'
      }
    }
  }, [_vm._v("Register")])], 1)], 1), _vm._v(" "), (_vm.getToken()) ? _c('nav', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dashboard'
      }
    }
  }, [_vm._v("Dashboard")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Analysis'
      }
    }
  }, [_vm._v("Analysis")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'History'
      }
    }
  }, [_vm._v("Fuelling History")])], 1) : _vm._e(), _vm._v(" "), _c('main', [(_vm.app.messages.length) ? _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, _vm._l((_vm.app.messages), function(message, index) {
    return _c('el-alert', {
      key: index,
      attrs: {
        "title": message,
        "type": "info",
        "show-icon": ""
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('footer', [_c('el-row', [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12
    }
  }, [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "http://www.cenex.co.uk/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tAbout Cenex\n\t\t\t\t\t\t")])]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Terms'
      }
    }
  }, [_vm._v("Terms & Conditions")])], 1)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12
    }
  }, [_c('p', [_vm._v("\n\t\t\t\t\t© 2017 Cenex\n\t\t\t\t")])])], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 633:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top",
      "label-width": "200px"
    }
  }, [_c('h1', [_vm._v("New Entry")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Refuelled at:"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "placeholder": "Please enter the date and time of this refuel",
      "disabled": _vm.app.isLoading,
      "type": "datetime",
      "format": "dd/MM/yyyy HH:mm",
      "clearable": false
    },
    model: {
      value: (_vm.local.refueled_at),
      callback: function($$v) {
        _vm.local.refueled_at = $$v
      },
      expression: "local.refueled_at"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Refuelling Amount (KG):"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Please enter in KGs",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.local.refuelling_amount.$touch()
      }
    },
    model: {
      value: (_vm.local.refuelling_amount),
      callback: function($$v) {
        _vm.local.refuelling_amount = $$v
      },
      expression: "local.refuelling_amount"
    }
  }), _vm._v(" "), (_vm.$v.local.refuelling_amount.$error) ? _c('div', [_c('div', {
    staticClass: "el-form-item__error"
  }, [(!_vm.$v.local.refuelling_amount.decimal) ? _c('span', [_vm._v("Please enter a valid number.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.local.refuelling_amount.required) ? _c('span', [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.local.refuelling_amount.maxLength) ? _c('span', [_vm._v("This value is too large.")]) : _vm._e()])]) : _vm._e()], 1), _vm._v(" "), (_vm.app.user.vehicle_model === 'Symbio') ? _c('el-form-item', {
    attrs: {
      "label": "Electricity Amount (kWh):"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Please enter in kWh",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.local.electricity_amount.$touch()
      }
    },
    model: {
      value: (_vm.local.electricity_amount),
      callback: function($$v) {
        _vm.local.electricity_amount = $$v
      },
      expression: "local.electricity_amount"
    }
  }), _vm._v(" "), (_vm.$v.local.electricity_amount.$error) ? _c('div', [_c('div', {
    staticClass: "el-form-item__error"
  }, [(!_vm.$v.local.electricity_amount.decimal) ? _c('span', [_vm._v("Please enter a valid number.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.local.electricity_amount.required) ? _c('span', [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.local.electricity_amount.maxLength) ? _c('span', [_vm._v("This value is too large.")]) : _vm._e()])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": 'Odometer Reading (' + _vm.app.user.units + '):'
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": 'Please enter your odometer reading in ' + _vm.app.user.units,
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.local.odometer_reading.$touch()
      }
    },
    model: {
      value: (_vm.local.odometer_reading),
      callback: function($$v) {
        _vm.local.odometer_reading = $$v
      },
      expression: "local.odometer_reading"
    }
  }), _vm._v(" "), (_vm.$v.local.odometer_reading.$error) ? _c('div', [_c('div', {
    staticClass: "el-form-item__error"
  }, [(!_vm.$v.local.odometer_reading.numeric) ? _c('span', [_vm._v("Please enter a valid number.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.local.odometer_reading.required) ? _c('span', [_vm._v("Field is required.")]) : _vm._e()])]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": 'Price (' + _vm.app.loadCurrencySymbol(_vm.app.user.currency) + '):'
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": 'Optional: Please enter a price in ' + _vm.app.loadCurrencySymbol(_vm.app.user.currency),
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.local.price.$touch()
      }
    },
    model: {
      value: (_vm.local.price),
      callback: function($$v) {
        _vm.local.price = $$v
      },
      expression: "local.price"
    }
  }), _vm._v(" "), (_vm.$v.local.price.$error) ? _c('div', [_c('div', {
    staticClass: "el-form-item__error"
  }, [(!_vm.$v.local.price.decimal) ? _c('span', [_vm._v("Please enter a valid number.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.local.price.maxLength) ? _c('span', [_vm._v("This value is too large.")]) : _vm._e()])]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Station Location: "
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Optional: Please enter the refuelling location",
      "disabled": _vm.app.isLoading
    },
    model: {
      value: (_vm.local.refuelling_station_location),
      callback: function($$v) {
        _vm.local.refuelling_station_location = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "local.refuelling_station_location "
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Notes: "
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Optional: Please enter any additional notes about this refuel",
      "type": "textarea",
      "autosize": ""
    },
    model: {
      value: (_vm.local.notes),
      callback: function($$v) {
        _vm.local.notes = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "local.notes "
    }
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.$v.$invalid || _vm.app.isLoading,
      "loading": _vm.app.isLoading
    },
    on: {
      "click": _vm.addEntry
    }
  }, [_vm._v("Add Entry")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 634:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top",
      "label-width": "200px"
    }
  }, [_c('h1', [_vm._v("Edit Entry")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Refuelled at:"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": _vm.app.isLoading,
      "type": "datetime",
      "format": "dd/MM/yyyy HH:mm",
      "clearable": false
    },
    model: {
      value: (_vm.local.refueled_at),
      callback: function($$v) {
        _vm.local.refueled_at = $$v
      },
      expression: "local.refueled_at"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Refuelling Amount (KG):"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Please enter in KGs",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.local.refuelling_amount.$touch()
      }
    },
    model: {
      value: (_vm.local.refuelling_amount),
      callback: function($$v) {
        _vm.local.refuelling_amount = $$v
      },
      expression: "local.refuelling_amount"
    }
  }), _vm._v(" "), (_vm.$v.local.refuelling_amount.$error) ? _c('div', [_c('div', {
    staticClass: "el-form-item__error"
  }, [(!_vm.$v.local.refuelling_amount.decimal) ? _c('span', [_vm._v("Please enter a valid number.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.local.refuelling_amount.required) ? _c('span', [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.local.refuelling_amount.maxLength) ? _c('span', [_vm._v("This value is too large.")]) : _vm._e()])]) : _vm._e()], 1), _vm._v(" "), (_vm.app.user.vehicle_model === 'Symbio') ? _c('el-form-item', {
    attrs: {
      "label": "Electricity Amount (kWh):"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Please enter in kWh",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.local.electricity_amount.$touch()
      }
    },
    model: {
      value: (_vm.local.electricity_amount),
      callback: function($$v) {
        _vm.local.electricity_amount = $$v
      },
      expression: "local.electricity_amount"
    }
  }), _vm._v(" "), (_vm.$v.local.electricity_amount.$error) ? _c('div', [_c('div', {
    staticClass: "el-form-item__error"
  }, [(!_vm.$v.local.electricity_amount.decimal) ? _c('span', [_vm._v("Please enter a valid number.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.local.electricity_amount.required) ? _c('span', [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.local.electricity_amount.maxLength) ? _c('span', [_vm._v("This value is too large.")]) : _vm._e()])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": 'Odometer Reading (' + _vm.app.user.units + '):'
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": 'Please enter your odometer reading in ' + _vm.app.user.units,
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.local.odometer_reading.$touch()
      }
    },
    model: {
      value: (_vm.local.odometer_reading),
      callback: function($$v) {
        _vm.local.odometer_reading = $$v
      },
      expression: "local.odometer_reading"
    }
  }), _vm._v(" "), (_vm.$v.local.odometer_reading.$error) ? _c('div', [_c('div', {
    staticClass: "el-form-item__error"
  }, [(!_vm.$v.local.odometer_reading.numeric) ? _c('span', [_vm._v("Please enter a valid number.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.local.odometer_reading.required) ? _c('span', [_vm._v("Field is required.")]) : _vm._e()])]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": 'Price (' + _vm.app.loadCurrencySymbol(_vm.app.user.currency) + '):'
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": 'Optional: Please enter a price in ' + _vm.app.loadCurrencySymbol(_vm.app.user.currency),
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.local.price.$touch()
      }
    },
    model: {
      value: (_vm.local.price),
      callback: function($$v) {
        _vm.local.price = $$v
      },
      expression: "local.price"
    }
  }), _vm._v(" "), (_vm.$v.local.price.$error) ? _c('div', [_c('div', {
    staticClass: "el-form-item__error"
  }, [(!_vm.$v.local.price.decimal) ? _c('span', [_vm._v("Please enter a valid number.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.local.price.maxLength) ? _c('span', [_vm._v("This value is too large.")]) : _vm._e()])]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Station Location: "
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Optional: Please enter the refuelling location",
      "disabled": _vm.app.isLoading
    },
    model: {
      value: (_vm.local.refuelling_station_location),
      callback: function($$v) {
        _vm.local.refuelling_station_location = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "local.refuelling_station_location "
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Notes: "
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Optional: Please enter any additional notes about this refuel",
      "type": "textarea",
      "autosize": ""
    },
    model: {
      value: (_vm.local.notes),
      callback: function($$v) {
        _vm.local.notes = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "local.notes "
    }
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.$v.$invalid || _vm.app.isLoading,
      "loading": _vm.app.isLoading
    },
    on: {
      "click": _vm.updateEntry
    }
  }, [_vm._v("Update Entry")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.showConfirmDelete
    }
  }, [_vm._v("Delete Entry")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 635:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container--wide"
  }, [_c('h1', [_vm._v("Analysis")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.app.entries.length) ? _c('div', [_c('h2', [_vm._v("Hydrogen Fuelled Per Month")]), _vm._v(" "), _c('LineChart', {
    attrs: {
      "chartData": _vm.hydrogenFuelled,
      "options": _vm.chartOptionsH
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.app.user.vehicle_model === 'Symbio') ? _c('div', [_c('h2', [_vm._v("Electricity Charged Per Month")]), _vm._v(" "), _c('LineChart', {
    attrs: {
      "chartData": _vm.electricityFuelled,
      "options": _vm.chartOptionsE
    }
  }), _vm._v(" "), _c('hr')], 1) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("Cost Per Month")]), _vm._v(" "), _c('line-chart', {
    attrs: {
      "chartData": _vm.cost,
      "options": _vm.chartOptionsC
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'History'
      },
      "tag": "el-button"
    }
  }, [_vm._v("\n\t\t\t\tView All Data\n\t\t\t")])], 1)], 1) : _c('div', [_c('h2', [_vm._v("You currently don't have any data to analyse.")]), _vm._v(" "), _c('p', [_vm._v("As you start to add entries to this app, we will show you the break down of cost and hydrogen fuelled over the your distance traveled.")]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dashboard'
      },
      "tag": "el-button"
    }
  }, [_vm._v("\n\t\t\t\tAdd entry\n\t\t\t")])], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 636:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10,
      "lg": 8
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top",
      "label-width": "100px"
    }
  }, [_c('h1', [_vm._v("Reset")]), _vm._v(" "), _c('p', [_vm._v("Please enter your new password.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Password:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Password",
      "type": "password",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.password.$touch()
      }
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.credentials.password = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.password"
    }
  }), _vm._v(" "), (_vm.$v.credentials.password.$error) ? _c('span', [(!_vm.$v.credentials.password.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.password.minLength) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Email must have at least " + _vm._s(_vm.$v.credentials.password.$params.minLength.min) + " characters.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Repeat Password:"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Password",
      "type": "password",
      "disabled": _vm.app.isLoading
    },
    on: {
      "input": function($event) {
        _vm.$v.credentials.repeatPassword.$touch()
      }
    },
    model: {
      value: (_vm.credentials.repeatPassword),
      callback: function($$v) {
        _vm.credentials.repeatPassword = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "credentials.repeatPassword"
    }
  }), _vm._v(" "), (_vm.$v.credentials.repeatPassword.$error) ? _c('span', [(!_vm.$v.credentials.repeatPassword.required) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Field is required.")]) : _vm._e(), _vm._v(" "), (!_vm.$v.credentials.repeatPassword.sameAsPassword) ? _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v("Passwords must be identical.")]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_c('el-button', {
    attrs: {
      "type": "button",
      "disabled": _vm.$v.$invalid || _vm.app.isLoading,
      "loading": _vm.app.isLoading
    },
    on: {
      "click": function($event) {
        _vm.resetPassword()
      }
    }
  }, [_vm._v("\n\t\t\t\t\tReset Password\n\t\t\t\t")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 637:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12
    }
  }, [_c('h1', [_vm._v("Terms & Conditions")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', [_vm._v("Data Controller and Owner")]), _vm._v(" "), _c('p', [_vm._v("Cenex "), _c('br'), _vm._v("\n\t\tAdvanced Technology Innovation Centre "), _c('br'), _vm._v("\n\t\tOakwood Drive "), _c('br'), _vm._v("\n\t\tLoughborough "), _c('br'), _vm._v("\n\t\tLeicestershire "), _c('br'), _vm._v("\n\t\tLE11 3QF")]), _vm._v(" "), _c('p', [_vm._v("Owner contact email: "), _c('a', {
    attrs: {
      "href": "mailto:info@cenex.co.uk"
    }
  }, [_vm._v("info@cenex.co.uk")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', [_vm._v("Types of Data collected")]), _vm._v(" "), _c('p', [_vm._v("Among the types of Personal Data that this Application collects, by itself or through third parties, there are: Cookies, Usage Data and email address.")]), _vm._v(" "), _c('p', [_vm._v("Complete details on each type of Personal Data collected are provided in the dedicated sections of this privacy policy or by specific explanation texts displayed prior to the Data collection.")]), _vm._v(" "), _c('p', [_vm._v("The Personal Data may be freely provided by the User, or, in case of Usage Data, collected automatically when using this Application.")]), _vm._v(" "), _c('p', [_vm._v("All Data requested by this Application is mandatory and failure to provide this Data may make it impossible for this Application to provide its services. In cases where this Application specifically states that some Data is not mandatory, Users are free not to communicate this Data without any consequences on the availability or the functioning of the service.")]), _vm._v(" "), _c('p', [_vm._v("Users who are uncertain about which Personal Data is mandatory are welcome to contact the Owner.")]), _vm._v(" "), _c('p', [_vm._v("Any use of Cookies – or of other tracking tools – by this Application or by the owners of third party services used by this Application serves the purpose of providing the service required by the User, in addition to any other purposes described in the present document and in the Cookie Policy, if available.")]), _vm._v(" "), _c('p', [_vm._v("Users are responsible for any third party Personal Data obtained, published or shared through this Application and confirm that they have the third party's consent to provide the Data to the Owner.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', [_vm._v("Mode and place of processing the Data")]), _vm._v(" "), _c('h3', [_vm._v("Methods of processing")]), _vm._v(" "), _c('p', [_vm._v("The Data Controller processes the Data of Users in a proper manner and shall take appropriate security measures to prevent unauthorized access, disclosure, modification, or unauthorized destruction of the Data.")]), _vm._v(" "), _c('p', [_vm._v("The Data processing is carried out using computers and/or IT enabled tools, following organizational procedures and modes strictly related to the purposes indicated. In addition to the Data Controller, in some cases, the Data may be accessible to certain types of persons in charge, involved with the operation of the site (administration, sales, marketing, legal, system administration) or external parties (such as third party technical service providers, mail carriers, hosting providers, IT companies, communications agencies) appointed, if necessary, as Data Processors by the Owner. The updated list of these parties may be requested from the Data Controller at any time.")]), _vm._v(" "), _c('h3', [_vm._v("Place")]), _vm._v(" "), _c('p', [_vm._v("The Data is processed at the Data Controller's operating offices and in any other places where the parties involved with the processing are located. For further information, please contact the Data Controller.")]), _vm._v(" "), _c('h3', [_vm._v("Retention time")]), _vm._v(" "), _c('p', [_vm._v("The Data is kept for the time necessary to provide the service requested by the User, or stated by the purposes outlined in this document, and the User can always request that the Data Controller suspend or remove the data.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', [_vm._v("The use of the collected Data")]), _vm._v(" "), _c('p', [_vm._v("The Data concerning the User is collected to allow the Owner to provide its services, as well as for the following purposes: Analytics and Contacting the User.")]), _vm._v(" "), _c('p', [_vm._v("The Personal Data used for each purpose is outlined in the specific sections of this document.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', [_vm._v("Detailed information on the processing of Personal Data")]), _vm._v(" "), _c('p', [_vm._v("Personal Data is collected for the following purposes and using the following services:")]), _vm._v(" "), _c('h3', [_vm._v("Email Registration")]), _vm._v(" "), _c('p', [_vm._v("By filling in the registration form with their email, the User authorizes this Application to use these details, unless otherwise stated, to reply to requests for information, quotes or any other kind of request as indicated by the form’s header.")]), _vm._v(" "), _c('p', [_vm._v("Personal Data collected: email address.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', [_vm._v("Additional information about Data collection and processing")]), _vm._v(" "), _c('h3', [_vm._v("Legal action")]), _vm._v(" "), _c('p', [_vm._v("The User's Personal Data may be used for legal purposes by the Data Controller, in Court or in the stages leading to possible legal action arising from improper use of this Application or the related services.")]), _vm._v(" "), _c('p', [_vm._v("The User declares to be aware that the Data Controller may be required to reveal personal data upon request of public authorities.")]), _vm._v(" "), _c('h3', [_vm._v("Additional information about User's Personal Data")]), _vm._v(" "), _c('p', [_vm._v("In addition to the information contained in this privacy policy, this Application may provide the User with additional and contextual information concerning particular services or the collection and processing of Personal Data upon request.")]), _vm._v(" "), _c('h3', [_vm._v("System logs and maintenance")]), _vm._v(" "), _c('p', [_vm._v("For operation and maintenance purposes, this Application and any third party services may collect files that record interaction with this Application (System logs) or use for this purpose other Personal Data (such as IP Address).")]), _vm._v(" "), _c('h3', [_vm._v("Information not contained in this policy")]), _vm._v(" "), _c('p', [_vm._v("More details concerning the collection or processing of Personal Data may be requested from the Data Controller at any time. Please see the contact information at the beginning of this document.")]), _vm._v(" "), _c('h3', [_vm._v("The rights of Users")]), _vm._v(" "), _c('p', [_vm._v("Users have the right, at any time, to know whether their Personal Data has been stored and can consult the Data Controller to learn about their contents and origin, to verify their accuracy or to ask for them to be supplemented, cancelled, updated or corrected, or for their transformation into anonymous format or to block any data held in violation of the law, as well as to oppose their treatment for any and all legitimate reasons. Requests should be sent to the Data Controller at the contact information set out above.")]), _vm._v(" "), _c('p', [_vm._v("This Application does not support “Do Not Track” requests.")]), _vm._v(" "), _c('p', [_vm._v("To determine whether any of the third party services it uses honor the “Do Not Track” requests, please read their privacy policies.")]), _vm._v(" "), _c('h3', [_vm._v("Changes to this privacy policy")]), _vm._v(" "), _c('p', [_vm._v("The Data Controller reserves the right to make changes to this privacy policy at any time by giving notice to its Users on this page. It is strongly recommended to check this page often, referring to the date of the last modification listed at the bottom. If a User objects to any of the changes to the Policy, the User must cease using this Application and can request that the Data Controller remove the Personal Data. Unless stated otherwise, the then-current privacy policy applies to all Personal Data the Data Controller has about Users.")]), _vm._v(" "), _c('h3', [_vm._v("Information about this privacy policy")]), _vm._v(" "), _c('p', [_vm._v("The Data Controller is responsible for this privacy policy, prepared starting from the modules provided by Iubenda and hosted on Iubenda's servers.")])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 7:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = setToken;
/* harmony export (immutable) */ __webpack_exports__["b"] = getToken;
/* unused harmony export removeToken */
/* harmony export (immutable) */ __webpack_exports__["a"] = endSession;
/* harmony export (immutable) */ __webpack_exports__["e"] = requireAuth;
/* harmony export (immutable) */ __webpack_exports__["g"] = checkAuth;
/* harmony export (immutable) */ __webpack_exports__["d"] = isAuthed;
/* harmony export (immutable) */ __webpack_exports__["c"] = getUser;
/* harmony export (immutable) */ __webpack_exports__["h"] = setUser;
/* unused harmony export removeUser */
/* unused harmony export parseJWT */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_store__ = __webpack_require__(8);





function setToken(token) {
	if (!token) return false;
	parseJWT(token);
	localStorage.setItem("token", token);
}

function getToken() {
	var token = localStorage.getItem("token");
	setToken(token);
	return token;
}

function removeToken() {
	return localStorage.removeItem("token");
}

function endSession() {
	removeToken();
	removeUser();
	__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push("/");
	__WEBPACK_IMPORTED_MODULE_3__utils_store__["a" /* default */].messages.push("You have now logged out.");
}

function requireAuth(to, from, next) {
	__WEBPACK_IMPORTED_MODULE_3__utils_store__["a" /* default */].messages = [];
	if (!getToken()) {
		next({
			path: "/"
		});
	} else {
		next();
	}
}
function checkAuth(error) {
	if (error.request.status === 401) {
		__WEBPACK_IMPORTED_MODULE_3__utils_store__["a" /* default */].credentials = {};
		removeToken();
		removeUser();
		__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push("/");
		__WEBPACK_IMPORTED_MODULE_3__utils_store__["a" /* default */].messages.push("Your session has ended, please login again");
	}
}
function isAuthed(to, from, next) {
	__WEBPACK_IMPORTED_MODULE_3__utils_store__["a" /* default */].messages = [];
	if (getToken()) {
		next({
			path: "/dashboard"
		});
	} else {
		next();
	}
}
function getUser() {
	return JSON.parse(localStorage.getItem("user"));
}

function setUser(user) {
	__WEBPACK_IMPORTED_MODULE_3__utils_store__["a" /* default */].user = user;
	return localStorage.setItem("user", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user));
}

function removeUser(user) {
	__WEBPACK_IMPORTED_MODULE_3__utils_store__["a" /* default */].user = false;
	return localStorage.removeItem("user");
}

function parseJWT(token) {
	var base64Url = token.split(".")[1];
	var base64 = base64Url.replace("-", "+").replace("_", "/");
	return __WEBPACK_IMPORTED_MODULE_3__utils_store__["a" /* default */].credentials = JSON.parse(window.atob(base64));
}

/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth__ = __webpack_require__(7);

/* harmony default export */ __webpack_exports__["a"] = ({
	isOnline: true,
	isLoading: false,
	credentials: false,
	user: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__auth__["c" /* getUser */])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__auth__["c" /* getUser */])() : false,
	messages: [],
	entryCache: [],
	entries: [],
	temp: {
		refueling: {
			refuelling_amount: "",
			odometer_reading: "",
			price: "",
			refueled_at: "",
			refuelling_station_location: "",
			electricity_amount: "",
			notes: ""
		}
	},
	currencySymbols: {
		EUR: "€",
		GBP: "£",
		ISK: "Íkr",
		CHF: "Fr",
		DKK: "kr",
		SEK: "kr",
		PLN: "zł",
		CZK: "Kč"
	},
	loadCurrencySymbol: function loadCurrencySymbol(ISOCode) {
		if (this.currencySymbols.hasOwnProperty(ISOCode)) {
			return this.currencySymbols[ISOCode];
		}
		return "€";
	}
});

/***/ })

},[341]);


// WEBPACK FOOTER //
// static/js/app.3774a5f7a5a8fbcb83d3.js